import { useFeatureCardForm } from "@/components/shared/forms/feature-card-form";
import type { CommonColor } from "@stackje/common/config";

export function AddFeatureCard(defaultType: "feature1" | "feature2", defaultColors: CommonColor) {
  const { formContent, previewContent, toggleType, shuffleColors, handleSubmit } = useFeatureCardForm({
    initialData: {
      title: "",
      subtitle: "",
      features: [],
      type: defaultType,
      colors: defaultColors,
    },
    mode: "add",
  });

  return {
    formContent,
    previewContent,
    toggleType,
    shuffleColors,
    handleSubmit,
  };
}
